export function error(msg) {
  if (msg) {
    document.getElementById('submit-btn').hidden = true
    document.getElementById('infoMsgWrapper').hidden = true
    document.getElementById('errorMsgWrapper').hidden = false
    document.getElementById('errorMsg').innerText = msg
  } else {
    document.getElementById('submit-btn').hidden = false
    document.getElementById('infoMsgWrapper').hidden = true
    document.getElementById('errorMsgWrapper').hidden = true
    document.getElementById('errorMsg').innerText = ''
  }
}

export function status(msg) {
  if (!document.getElementById('errorMsgWrapper').hidden) return
  if (msg) {
    document.getElementById('submit-btn').hidden = true
    document.getElementById('errorMsgWrapper').hidden = true
    document.getElementById('infoMsgWrapper').hidden = false
    document.getElementById('infoMsg').innerText = msg
  } else {
    document.getElementById('submit-btn').hidden = false
    document.getElementById('errorMsgWrapper').hidden = true
    document.getElementById('infoMsgWrapper').hidden = true
    document.getElementById('infoMsg').innerText = ''
  }
}

export function init() {
  document.getElementById('errorMsgClose').addEventListener('click', () => {
    error()
  })
}

export default error